//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/Builder.js";
import "../Weld/Weld.CharacteristicsBuilder.js";
import "../no/Section.js";
import "../no/SelectNXObjectList.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BackEdgeOffset",1,0],[0,"DistanceTolerance",1,0],[0,"GridAngleTolerance",1,0],[0,"GridIncrement",1,0],[0,"Height",1,0],[0,"HemMethod",1,0],[0,"LengthAndWidth",1,0],[0,"MaximumSpacing",1,0],[0,"MinimumFlangeWidth",1,0],[0,"NumberSurfaceVectors",1,0],[1,"OtherCharacteristics",0,"Weld.CharacteristicsBuilder",0],[1,"PatternPath",0,"Section",0],[1,"PatternSelPoints",0,"SelectNXObjectList",0],[0,"PlaneLocation",1,0],[0,"PlaneMethod",1,0],[1,"PrimaryCharacteristics",0,"Weld.CharacteristicsBuilder",0],[0,"ProjectAlongDirection",1,0],[0,"ReverseDirection",1,0],[0,"SpacingMethod",1,0],[1,"SurfaceVectorFace",0,"ScCollector",0],[0,"TrimEdgeOffset",1,0],[0,"Type",1,0],[1,"UserPlanes",0,"SelectNXObjectList",0]],[],[]];
SPLM.Weld.EasyPatternBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.EasyPatternBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.EasyPatternBuilder.Types = Object.freeze({
    "TrimAndSurface" : "TrimAndSurface", "HemAndSurface" : "HemAndSurface", "Surface" : "Surface", "Trim" : "Trim", "Hem" : "Hem", "SurfacePoints" : "SurfacePoints"});

SPLM.Weld.EasyPatternBuilder.PlaneMethodTypes = Object.freeze({
    "InferPlanes" : "InferPlanes", "ParallelXCPlanes" : "ParallelXCPlanes", "ParallelYCPlanes" : "ParallelYCPlanes", "ParallelZCPlanes" : "ParallelZCPlanes", "SelectPlanes" : "SelectPlanes"});

SPLM.Weld.EasyPatternBuilder.SpacingMethodTypes = Object.freeze({
    "Grid" : "Grid", "SinglePlane" : "SinglePlane"});

SPLM.Weld.EasyPatternBuilder.HemMethodTypes = Object.freeze({
    "MidPoint" : "MidPoint", "NormalToBody" : "NormalToBody"});

SPLM.Weld.EasyPatternBuilder.SurfaceVectorCount = Object.freeze({
    "One" : "One", "Two" : "Two"});

export default SPLM;